<div class="col-xl period-receipts-wrap">
    <div class="employee-breadcrumb mb-3">
        <a [routerLink]="['/payroll-periods']">Administrador de periodos</a> /
        <a [routerLink]="['/payroll-receipts']">Recibos electrónicos</a> /
        <span class="current">Consulta de periodo {{periodDateLabel}}</span>
    </div>

    <div class="row g-3 mb-4 payroll-kpi-row">
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ccf0ff;"><img src="assets/img/icons/payroll-kpi-file-text.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total de recibos electrónicos</p>
                    <p class="payroll-kpi-value">{{stats.total}}</p>
                    <p class="payroll-kpi-sublabel">Periodo {{periodDateLabel}}</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#e3fbe8;"><img src="assets/img/icons/payroll-kpi-check-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total recibos timbrados</p>
                    <p class="payroll-kpi-value">{{stats.stamped}}</p>
                    <p class="payroll-kpi-sublabel">{{stampedPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#fef3d4;"><img src="assets/img/icons/payroll-kpi-clock.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Pendientes</p>
                    <p class="payroll-kpi-value">{{stats.pending}}</p>
                    <p class="payroll-kpi-sublabel">{{pendingPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ffccce;"><img src="assets/img/icons/payroll-kpi-alert-circle.svg" alt=""></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Con error</p>
                    <p class="payroll-kpi-value">{{stats.error}}</p>
                    <p class="payroll-kpi-sublabel">{{errorPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card payroll-kpi-card-net">
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total neto pagado del período</p>
                    <p class="payroll-kpi-value">{{formatCurrency(stats.net_period_total)}}</p>
                    <p class="payroll-kpi-sublabel">{{stats.total}} recibos</p>
                </div>
            </div>
        </div>
    </div>

    <div class="payroll-tabs mb-0">
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'all'" (click)="setTab('all')">
            Todos <span class="payroll-tab-badge" style="background:#ccf0ff;color:#006d99;">{{stats.total}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'pending'" (click)="setTab('pending')">
            Pendientes <span class="payroll-tab-badge" style="background:#fef3d4;color:#cf8515;">{{stats.pending}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'stamped'" (click)="setTab('stamped')">
            Timbrado <span class="payroll-tab-badge" style="background:#e3fbe8;color:#3c7e43;">{{stats.stamped}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'error'" (click)="setTab('error')">
            Error <span class="payroll-tab-badge" style="background:#ffccce;color:#c5010b;">{{stats.error}}</span>
        </button>
    </div>

    <div class="card mb-4 period-receipts-panel">
        <div class="card-body">
            <div class="d-flex flex-wrap align-items-end gap-3 mb-3">
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Nombre y apellido</label>
                    <div class="receipts-filter-input">
                        <input type="text" placeholder="Buscar" [(ngModel)]="filterSearch" (ngModelChange)="onSearchChanged()">
                    </div>
                </div>
                <div class="receipts-filter-group">
                    <label class="receipts-filter-label">Estado CFDI</label>
                    <div class="receipts-filter-input">
                        <select [(ngModel)]="activeTab" (ngModelChange)="fetchReceipts()">
                            <option value="all">Seleccionar</option>
                            <option value="pending">Pendiente</option>
                            <option value="stamped">Timbrado</option>
                            <option value="error">Error</option>
                        </select>
                    </div>
                </div>
                <button type="button" class="period-receipts-stamp-massive-btn ms-auto" *ngIf="canDo('Timbrar')" (click)="stampMassive()">
                    <img src="assets/img/icons/icon-qr-code.svg" alt=""> Timbrado masivo
                </button>
            </div>

            <div class="period-receipts-table-wrap" *ngIf="!loading && !loadError">
                <table class="period-receipts-table">
                    <thead>
                        <tr>
                            <th>Colaborador</th>
                            <th>Periodo de pago</th>
                            <th class="text-center">Neto a pagar</th>
                            <th class="text-center">Estado CFDI</th>
                            <th class="text-center">Fecha timbrado</th>
                            <th class="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of visibleRows">
                            <td>
                                <a href="javascript:void(0)" class="period-receipts-name-link" (click)="viewReceipt(row)">{{getEmployeeName(row)}}</a>
                            </td>
                            <td>{{formatPeriodRange(row)}}</td>
                            <td class="text-center">{{formatCurrency(row.net_paid)}}</td>
                            <td class="text-center">
                                <span class="period-receipts-status-badge" *ngIf="statusMeta(row.cfdi_status) as meta"
                                    [style.background]="meta.bg" [style.color]="meta.color">{{meta.label}}</span>
                            </td>
                            <td class="text-center">{{row.certification_datetime ? formatDate(row.certification_datetime) : '--/--/----'}}</td>
                            <td class="text-center">
                                <img src="assets/img/icons/icon-eye.svg" class="period-receipts-action-icon" title="Ver recibo" (click)="viewReceipt(row)">
                                <img *ngIf="row.cfdi_status === 'stamped'" src="assets/img/icons/icon-download-04.svg"
                                    class="period-receipts-action-icon" title="Descargar" (click)="downloadPdf(row)">
                                <img *ngIf="row.cfdi_status === 'pending' && canDo('Timbrar')" src="assets/img/icons/icon-qr-code-small.svg"
                                    class="period-receipts-action-icon" title="Generar timbrado" (click)="stampSingle(row)">
                                <img *ngIf="row.cfdi_status === 'error' && canDo('Timbrar')" src="assets/img/icons/icon-reload-round.svg"
                                    class="period-receipts-action-icon" title="Reintentar timbrado" (click)="stampSingle(row)">
                            </td>
                        </tr>
                        <tr *ngIf="!allRows.length">
                            <td colspan="6" class="text-center text-muted py-4">No se encontraron recibos para este periodo</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="period-receipts-empty-state" *ngIf="loadError">
                <i class="ti ti-file-x"></i>
                <p class="mb-0">No se pudo cargar el listado de recibos de nómina.</p>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center" *ngIf="!loading && !loadError">
            <div class="text-muted small">Total: {{totalRows}}</div>
            <div class="d-flex align-items-center">
                <label class="me-2 mb-0">Filas por página:</label>
                <select class="form-select form-select-sm me-2" style="width: auto;"
                    (change)="onPageSizeChanged($any($event.target).value)">
                    <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
                </select>
                <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()"
                    [disabled]="currentPage <= 1">
                    <i class="ti ti-chevron-left"></i>
                </button>
                <span class="me-2">Página {{currentPage}} de {{lastPage}}</span>
                <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()"
                    [disabled]="currentPage >= lastPage">
                    <i class="ti ti-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="period-receipts-banner">
        <i class="ti ti-info-circle"></i>
        Mostrando periodo {{periodDateLabel}}
        <button type="button" class="period-receipts-banner-btn" (click)="volverAlAdminDePeriodos()">
            <i class="ti ti-corner-up-left"></i>&nbsp;Volver al Admin. de periodos
        </button>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
